module.exports = "<span class=\"aggregate-header-left lead\"><i class=\"icon-filter\"></i>&nbsp; </span><span class=\"dimensions-header-center\"><input type=\"text\" class=\"search-keyword\" ng-keyup=\"$ctrl.searchKeyup($event)\" ng-model=\"$ctrl.value\" placeholder=\"{{:: 'Поиск - Ключевые слова' | gettext }}\"> </span><span class=\"ztop add-on dimensions-header-right\"><a title=\"{{:: 'Полнотекстовый поиск' | gettext }}\"><i class=\"icon-search\" ng-click=\"$ctrl.search()\"></i> </a></span>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/filter-search.component.html
// module id = 788
// module chunks = 0